<template>

  <Form ref="attendanceRecordsDrawerTable" :model="query" v-loading="loading" :disabled="actionType=='detail'"
        :label-width="100">
    <Row>
      <Col span="12">
        <FormItem :label="this.$t('ipms.attendance-user.attendanceGroup.label')" prop="attendanceGroup">
          <Select v-model="query.attendanceGroup" clearable filterable  @on-change="getAttendanceRecordsTableGroup"
                  :placeholder="$t('ipms.attendance-records.attendanceType.holder')" style="width: 120px">
            <Option v-for="item in zhangsan" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="this.$t('ipms.attendance-records.attendanceDate.label')" prop="attendanceDate">
          <div style="width: 120px">
            <Date-picker :value="query.attendanceDate" format="yyyy-MM-dd" @on-change="getAttendanceRecordsTable"
                         type="date"
                         :placeholder="this.$t('ipms.attendance-records.attendanceDate.holder')"></Date-picker>
          </div>
        </FormItem>
      </Col>
    </Row>





    <div class="input-box">
      <Row >

          <Col offset="1" span="5" v-for="(value, index) in arraydata" style="margin-top: 15px">
            <div style="display: flex;justify-content: space-between">
              <Input v-model="value.userName"  :disabled="false":placeholder="$t('ipms.attendance-user.userName.holder') "
                     style="width: 100px"/>
              <Select v-model="value.attendanceRecords.attendanceType" clearable filterable
                      :placeholder="$t('ipms.attendance-records.attendanceType.holder')" style="width: 100px">
                <Option v-for="item in dict.attendanceType" :value="item.dictKey"
                        :key="item.dictValue">{{ item.dictValue }}
                </Option>
              </Select>
            </div>

          </Col>
      </Row>
    </div>





  </Form>
  <!--s-->
</template>
<script type="text/jsx">
  import api from '@/api'
  import Vue from 'vue';
  import mixin from '@/libs/mixins/Index'
  import dict from '@/components/dict'
  export default {
    dictParams: ['attendanceGroup','attendanceType','userPost','userCategory'],
    components: {
      'dict-tag': dict
    },
    data() {
      return {
        arraydata: [],
        query: {
          attendanceGroup: null,
          attendanceDate: this.$moment().format(),
        },
        loading: false,
        actionType: 'add',
        data: [],
        zhangsan: []
      }
    },
    methods: {
      initAttendanceRecordsTable(query) {
        this.query.attendanceGroup = null
        this.loading = true;
        api.ipms.AttendanceRecords.getMember(query).then(data => {
          this.arraydata = data.map(item=>{
            item.attendanceRecords.attendanceType= parseInt(item.attendanceRecords.attendanceType);
            return item
          });
          this.loading = false;
          this.actionType = type;
          this.handleReset()
        }).catch(e => this.loading = false)

        api.ipms.AttendanceRecords.getGRoup()
          .then(data => {
            this.zhangsan = data
            this.query.attendanceGroup=data[0].value
          }).catch(error => this.page.loading = false)

      },
      handleSubmit(then, error) {
        this.loading = true;
        this.$refs['attendanceRecordsDrawerTable'].validate(valid => {
          if (valid) {
            this.createAttendanceRecords(this.arraydata).then(then).error(error)

          } else {
            this.$Message.error(this.$t('errorText'))
            error()
          }
        })
      },
      createAttendanceRecords(attendanceRecords) {
        this.loading = true;
        return api.ipms.AttendanceRecords.add(attendanceRecords)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
      },
      handleReset() {
        this.query.attendanceGroup = null
        this.query.attendanceDate = null
        this.query.attendanceDateBetween = null
        this.arraydata = []
        this.$nextTick(() => this.$refs['attendanceRecordsDrawerTable'].resetFields());
      },
      getAttendanceRecordsTable(format_value, date_time) {
          this.query.attendanceDate = format_value
        api.ipms.AttendanceRecords.getMember(this.query).then(data => {
          this.arraydata = data.map(item=>{
            item.attendanceRecords.attendanceType= parseInt(item.attendanceRecords.attendanceType);
            return item
          });

          this.loading = false;
          this.actionType = type;
          //this.handleReset()
        }).catch(e => this.loading = false)
      },
      getAttendanceRecordsTableGroup(format_value, date_time) {
        if(format_value.indexOf("-")==-1) {
          format_value = this.query.attendanceDate
          //console.log("前", format_value)
          format_value = format_value.split("T")[0];
        //  console.log("侯", format_value)
        }
        this.query.attendanceDate = format_value
        api.ipms.AttendanceRecords.getMember(this.query).then(data => {
          this.arraydata = data.map(item=>{
            item.attendanceRecords.attendanceType= parseInt(item.attendanceRecords.attendanceType);
            return item
          });

          this.loading = false;
          this.actionType = type;
          //this.handleReset()
        }).catch(e => this.loading = false)
      },
    },
    computed: {}
  }
</script>
<style>
  .input-box{
    padding: 15px;
    margin:0 auto;
  }
</style>
